import { Card, Col, Segmented, Table } from 'antd';
import styled from 'styled-components';
import { Editor as EditorDraft } from 'react-draft-wysiwyg';
export const ColButtons = styled(Col)`
  width: 99.5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const StyledSegmented = styled(Segmented)`
  display: flex;
  gap: 10px;
  background-color: transparent;
  .ant-segmented-item {
    background-color: #2e394b; // Cor de fundo das opções
    color: #ffffff; // Cor do texto
    margin-bottom: 10px;
    &:hover {
      background-color: #fad301; // Cor ao passar o mouse
      color: rgb(0, 0, 0);
    }

    &:focus-within {
      background-color: #fad301;
      color: rgb(0, 0, 0);
    }
  }
`;

export const Editor = styled(EditorDraft)`
  .editor-class {
    min-height: 200px;
    border: 1px solid #d9d9d9;
    padding: 10px;
    border-radius: 4px;
    background-color: #fff;
    overflow-y: auto;
  }

  .wrapper-class {
    margin-bottom: 16px;
  }

  .toolbar-class {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    margin-bottom: 8px;
    background-color: #f5f5f5;
  }
`;

export const ObservationsCard = styled(Card)`
  width: 100%;

  ${({ disabled }) =>
    disabled &&
    `
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: rgb(0, 0, 0);
    pointer-events: none;
    cursor: not-allowed !important;
  `}
`;

export const SmallTable = styled(Table)`
  .ant-table-tbody > tr > td {
    padding: 6px !important;
    font-size: 12px !important;
  }

  .ant-table-thead > tr > th {
    padding: 8px !important;
    font-size: 14px !important;
    height: 24px !important;
  }
`;
